import React, { Component } from 'react';
import SnpButtons from './SnpButtons'

class Snps extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      snpsError:null,
      snpsLoaded:false,
      snps: {},
      genomeError:null,
      genomeLoaded:false,
      genome:{}
    };
  }

  componentDidMount() {
    // Create an array of all snp ids needed in this component
    let totalsnps = [];
    let snps_obj = this.props.snps;
    let keys = Object.keys(snps_obj);
    let filenames = (this.props.filenames || []);
    
    for (let i=0;i<keys.length;i++) {
      let snps = [];
      if (Array.isArray(snps_obj[keys[i]])) {
        snps = snps_obj[keys[i]];
      } else {
        snps = snps_obj[keys[i]]["snps"];
        filenames.push(snps_obj[keys[i]]["filename"]);
      }
      
      totalsnps = totalsnps.concat(snps);
    }

    // Request the alleles and genes from api/read_snps.py
    let url = "https://moreygenetics.com/api/read_snps.py?snps="+totalsnps.join(",");
    filenames.length && (url += "&files=" + filenames.join(","));
    console.log(url);
    
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            snpsLoaded: true,
            snps: result
          });
        },
        (error) => {
          console.log(error);
          this.setState({
            snpsLoaded:true,
            snpsError:error
          });
        }
      )

    // Request data from api/read_genome.py
    // This request will need the snp ids and (if possible) the facebook access token
    // This returns the alleles from the 23andMe file (or * emoji's if no 23andMe file is available)
    url = "https://moreygenetics.com/api/read_genome.py?snps="+totalsnps.join(",");
    if (this.props.credential) {
      url += "&credential=" + this.props.credential;
    }
    console.log(url);
    
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            genomeLoaded: true,
            genome: result
          });
        },
        (error) => {
          console.log(error);
          this.setState({
            genomeLoaded:true,
            genomeError:error,
          });
        }
      )
  }

  render() {
    let snps_list = [];                 // a list of divs to return
    let snps_obj = this.props.snps;     // an object with snp ids
    const keys = Object.keys(snps_obj);

    for (let i=0;i<keys.length;i++) {
      let snps = (Array.isArray(snps_obj[keys[i]])) ? snps_obj[keys[i]] : snps_obj[keys[i]]["snps"];
      
      // Add the title for each group of SNPs
      snps_list.push(
        <div className="big_title" key={"title"+i}>{keys[i]}</div>
      );
      for (var j=0;j<snps.length;j++) {
        
        var snp_data = this.state.snps[snps[j]];
        //   console.log(snp_data);
        // snp data from the api/read_snps.py request
        // This is an object with the following keys :
        // "chr", "pos"           chromosome number, position
        // "min", "anc", "maf"    minor allele, ancestral allele, minor allele frequency
        // "genes"                a list of objects containing gene names and descriptions

        var genes = {};  // Create an object to store JSX fragments with the gene names and descriptions
        if (snp_data) {
          for (var k=0;k<snp_data["genes"].length;k++) {
            let gene = snp_data["genes"][k];
            genes[gene["name"]] = (
              <React.Fragment key={gene["name"]}>
                <a href={"https://www.ncbi.nlm.nih.gov/gene/?term=("+gene["name"]+"[Gene Name]) AND homo sapiens[Organism]"}
                  target="_blank" rel="noopener noreferrer"
                  >
                  <b>{gene["name"]}</b>&nbsp;{gene["desc"]}
                </a><br/>
              </React.Fragment>
            );
          }
        }

        // state.genome contains the data from the api/read_genome.py request
        var genome = "";
        var genome_keys = Object.keys(this.state.genome);
        if (genome_keys.includes(snps[j])) {
          genome = this.state.genome[snps[j]];
        }

        snps_list.push(
          <div className="snp" key={snps[j]}>
            <SnpButtons snp={snps[j]}/>
            <div className="snpdata"
              id={snps[j]}>
              <div className="title">{snps[j]}</div>
              {
                snp_data&&
                <div className="coords">
                  {snp_data["chr"]} : {snp_data["pos"].replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                  {Object.values(genes)}
                  Alleles: {snp_data["alleles"]}<br/>
                  Minor: {snp_data["min"]}<br/>
                  Minor Freq: {snp_data["maf"]}
                </div>
              }
            </div>
            <a target='new' style={{marginLeft:"auto"}} href={'https://you.23andme.com/tools/data/?query='+snps[j]}>
              <div className='allele'>{genome}</div>
            </a>
          </div>
        );
      }
    }

    return (
      <div id="snp_list">
        {snps_list}
      </div>
    );
  }
}

export default Snps;